export default "__VITE_ASSET__DUAufRcC__"